import { Col, Row, Image, Menu, Collapse, Tooltip } from 'antd';
import { PlusCircleOutlined, MinusCircleOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import Link from 'next/link';
import { useRouter } from "next/router";
import { useState, useEffect, useMemo, useRef } from 'react';
import { useSession, signIn, signOut } from "next-auth/react";
import UserProfileModal from "../pages/components/UserProfileModal"
import HelpFAQModal from "./HelpFAQModal"
import ComingSoonModal from "./ComingSoonModal"
import Avatar from "react-avatar";
import Modal from 'react-modal';
import styles from '../styles/UserProfile.module.css'
import { useTheme } from "next-themes";
import collapsibleStyles from '../styles/SidebarCollapsible.module.css';

export default function Sidebar({ sideMenuArrProp }) {
  const SIDEBAR_SET_COLLAPSED_EVENT = 'app:sidebar:set-collapsed';
  const SIDEBAR_COLLAPSED_CHANGED_EVENT = 'app:sidebar:collapsed-changed';
  const router = useRouter();
  const [selectedPath, setSelectedPath] = useState(0);
  let selectedIndexValue = 0;
  const { data: session } = useSession();
  const [sideMenuArr, setSideMenuArr] = useState(() => sideMenuArrProp ?? []);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalHelp, setIsModalHelp] = useState(false);
  const [isFAQOpen, setIsFAQOpen] = useState(false);
  const [comingSoonTitle, setComingSoonTitle] = useState('');
  const { theme, setTheme } = useTheme();
  const [fctLogo, setFctLogo] = useState('/images/FCT.png');
  // const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const mediaQueryRef = useRef(null);
  const sidebarRef = useRef(null);
  const flyoutCloseTimerRef = useRef(null);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [openFlyoutGroup, setOpenFlyoutGroup] = useState(null);
  const { Panel } = Collapse;
  const { groupedMenu, ungroupedMenu } = useMemo(() => {
    const grouped = {};
    const ungrouped = [];

    sideMenuArr.forEach(item => {
      if (item.Group) {
        if (!grouped[item.Group]) grouped[item.Group] = [];
        grouped[item.Group].push(item);
      } else {
        ungrouped.push(item);
      }
    });

    return { groupedMenu: grouped, ungroupedMenu: ungrouped };
  }, [sideMenuArr]);
  useEffect(() => {
    let isMounted = true;

    mediaQueryRef.current = window.matchMedia('(prefers-color-scheme: dark)');
    const prefersDarkMode = mediaQueryRef.current.matches;

    if (isMounted) {
      if (theme === 'dark' || prefersDarkMode) {
        setFctLogo('/images/FCT.png')
      }
      else {
        setFctLogo('/images/FCT.png')
      }
    }
    return () => {
      isMounted = false;
      mediaQueryRef.current = null;
    };
  }, [theme])

  useEffect(() => {
    const sidebarWrapper = sidebarRef.current?.parentElement;
    if (!sidebarWrapper) return;
    const currentSidebarWidth = isCollapsed ? '70px' : '220px';
    sidebarWrapper.style.width = currentSidebarWidth;
    sidebarWrapper.style.transition = 'width 0.25s ease';
    document.documentElement.style.setProperty('--app-sidebar-width', currentSidebarWidth);
    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent(SIDEBAR_COLLAPSED_CHANGED_EVENT, {
          detail: { collapsed: isCollapsed },
        })
      );
    }
    if (isCollapsed) {
      setOpenFlyoutGroup(null);
    }
  }, [isCollapsed]);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const handleSetCollapsed = (event) => {
      const nextCollapsed = event?.detail?.collapsed;
      if (typeof nextCollapsed === 'boolean') {
        setIsCollapsed(nextCollapsed);
      }
    };
    window.addEventListener(SIDEBAR_SET_COLLAPSED_EVENT, handleSetCollapsed);
    return () => {
      window.removeEventListener(SIDEBAR_SET_COLLAPSED_EVENT, handleSetCollapsed);
    };
  }, []);

  useEffect(() => {
    const currentSidebarEl = sidebarRef.current;
    return () => {
      if (flyoutCloseTimerRef.current) {
        clearTimeout(flyoutCloseTimerRef.current);
      }
      const sidebarWrapper = currentSidebarEl?.parentElement;
      if (sidebarWrapper) {
        sidebarWrapper.style.width = '';
        sidebarWrapper.style.transition = '';
      }
      document.documentElement.style.removeProperty('--app-sidebar-width');
    };
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const openHelpModal = () => {
    setIsModalHelp(true);

  };
  const closeHelpModal = () => {
    setIsModalHelp(false);
  };
  const userNameStyle = {
    color: 'white',
    fontWeight: 'bold'
  };

  const selected = {
    color: '#22b27e'
  }

  const unSelected = {
    color: 'white'
  }

  const openGroupFlyout = (groupName) => {
    if (flyoutCloseTimerRef.current) {
      clearTimeout(flyoutCloseTimerRef.current);
    }
    setOpenFlyoutGroup(groupName);
  };

  const scheduleFlyoutClose = () => {
    if (flyoutCloseTimerRef.current) {
      clearTimeout(flyoutCloseTimerRef.current);
    }
    flyoutCloseTimerRef.current = setTimeout(() => {
      setOpenFlyoutGroup(null);
    }, 120);
  };

  const keepFlyoutOpen = () => {
    if (flyoutCloseTimerRef.current) {
      clearTimeout(flyoutCloseTimerRef.current);
    }
  };

  // useEffect(() => {
  //   if (!session) {
  //     router.push("/");
  //   }
  // }, [session]);

  const activeRole = (typeof window !== 'undefined' && localStorage.getItem('activeRole')) || session?.user?.roles?.[0];



  //let sideMenuArr = [];

  // useEffect(() => {
  //   if (sideMenuArr && sideMenuArr.length > 0) {
  //     sideMenuArr.forEach((item) => {
  //       if (item["URL"]) {
  //         router.prefetch(item["URL"]);
  //       }
  //     });
  //   }
  // }, [sideMenuArr]);
  useEffect(() => {
    let isMounted = true;
    if (localStorage.getItem('menubardata') && sideMenuArr.length <= 0) {
      const menuObj = localStorage.getItem('menubardata');
      if (isMounted && menuObj) {
        try {
          const menuBar = JSON.parse(menuObj);
          if (menuBar?.dashboard?.[1]?.sideMenu) {
            setSideMenuArr(menuBar?.dashboard?.[1]?.sideMenu || []);
          }
        } catch (err) {
          console.error('Failed to parse menubardata:', err);
        }
      }
    }
    return () => {
      isMounted = false;
    };
  }, [sideMenuArr.length]);



  const role = activeRole;
  const renderMenuItem = (item, index) => {
    const isActive = router.pathname === item.URL;
    const linkStyle = isActive ? selected : unSelected;
    return (
      <li key={index} className={isActive ? 'active' : ''}>
        <Link legacyBehavior href={item.URL}>
          <a style={linkStyle}>
            <Image src={item.path} alt="" className="img-active" preview={false} style={{ marginRight: '8px' }} />
            <Image src={item.path} alt="" className="img-default" preview={false} style={{ marginRight: '8px' }} />
            <span>{item.Name}</span>
          </a>
        </Link>
      </li>
    );
  };

  const helpItemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    backgroundColor: '#f0f4f8',
    borderRadius: '8px',
    padding: '10px 12px',
    marginBottom: '10px',
    textDecoration: 'none',
    color: 'inherit',
    transition: 'background-color 0.2s ease',
  };

  const futureItemStyle = {
    opacity: 0.55,
    cursor: 'not-allowed',
  };

  const helpIconStyle = {
    fontSize: '20px',
    flexShrink: 0,
  };

  const badgeStyle = {
    marginLeft: '8px',
    fontSize: '10px',
    backgroundColor: '#e0f0ff',
    color: '#0c6fad',
    borderRadius: '4px',
    padding: '2px 6px',
    fontWeight: '500',
    verticalAlign: 'middle',
  };

  return (
    <>
      <div
        ref={sidebarRef}
        className={`main-sidebar ${collapsibleStyles.sidebarContainer} ${isCollapsed ? collapsibleStyles.collapsedSidebar : collapsibleStyles.expandedSidebar}`}
      >
        <Row align='middle' justify='space-between' className='sidebar-logo'>
          <Col>
            <Image
              src='/images/FCT.png'
              alt="Logo" height={isCollapsed ? 32 : 45} preview={false} />
          </Col>
          <Col>
            <button
              type="button"
              className={collapsibleStyles.collapseToggle}
              aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
              onClick={() => setIsCollapsed((prev) => !prev)}
            >
              {isCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </button>
          </Col>
        </Row>
        {/* <ul className="sidebar-list">
          {
            sideMenuArr && sideMenuArr.map((item, index) => (

              <li key={index} className={router.pathname === item["URL"] ? "active" : ""}>
                {
                  role === "External User" ?
                    <Link legacyBehavior href={item["URL"]} >
                      <a
                        style={
                          router.pathname === item["URL"] ? selected : unSelected
                        }
                      >
                        <Image src={item.path} className="img-active" preview={false} />
                        <Image src={item.path} className="img-default" preview={false} />
                        <span>{item.Name}</span>
                      </a>
                    </Link> :
                    <Link legacyBehavior href={item["URL"]}>
                      <a
                        style={
                          router.pathname === item["URL"] ? selected : unSelected
                        }
                      >
                        <Image src={item.path} className="img-active" preview={false} />
                        <Image src={item.path} className="img-default" preview={false} />
                        <span>{item.Name}</span>
                      </a>
                    </Link>
                }
              </li>
            ))
          }
        </ul> */}
        <div className={`sidebar-list ${collapsibleStyles.menuContainer}`}>
          {!isCollapsed && (
            <>
              <Collapse accordion bordered={false} expandIcon={({ isActive }) =>
                isActive ? <MinusCircleOutlined /> : <PlusCircleOutlined />
              }>
                {Object.entries(groupedMenu).map(([groupName, items]) => {
                  const isGroupActive = items.some(item => router.pathname === item.URL);
                  return (
                    <Panel header={groupName} className={isGroupActive ? 'active-group' : ''} key={groupName}>
                      <ul className="sidebar-list">
                        {items.map(renderMenuItem)}
                      </ul>
                    </Panel>
                  );
                })}
              </Collapse>
              <ul className="sidebar-list">
                {ungroupedMenu.map(renderMenuItem)}
              </ul>
            </>
          )}

          {isCollapsed && (
            <ul className={`sidebar-list ${collapsibleStyles.collapsedIconList}`}>
              {Object.entries(groupedMenu).map(([groupName, items]) => {
                const isGroupActive = items.some(item => router.pathname === item.URL);
                const groupIcon = items?.[0]?.path;
                return (
                  <li
                    key={groupName}
                    className={`${isGroupActive ? 'active' : ''} ${collapsibleStyles.collapsedIconItem}`}
                    onMouseEnter={() => openGroupFlyout(groupName)}
                    onMouseLeave={scheduleFlyoutClose}
                  >
                    <div className={collapsibleStyles.iconOnlyLink}>
                      {groupIcon && (
                        <>
                          <Image src={groupIcon} alt="" className="img-active" preview={false} />
                          <Image src={groupIcon} alt="" className="img-default" preview={false} />
                        </>
                      )}
                    </div>
                    {openFlyoutGroup === groupName && (
                      <div
                        className={collapsibleStyles.flyoutPanel}
                        onMouseEnter={keepFlyoutOpen}
                        onMouseLeave={scheduleFlyoutClose}
                      >
                        <div className={collapsibleStyles.flyoutHeader}>{groupName}</div>
                        <ul className={collapsibleStyles.flyoutList}>
                          {items.map((item, index) => {
                            const isActive = router.pathname === item.URL;
                            const linkStyle = isActive ? selected : unSelected;
                            return (
                              <li key={`${groupName}-${index}`} className={isActive ? collapsibleStyles.flyoutActive : ''}>
                                <Link legacyBehavior href={item.URL}>
                                  <a style={linkStyle}>
                                    <Image src={item.path} alt="" preview={false} />
                                    <span>{item.Name}</span>
                                  </a>
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    )}
                  </li>
                );
              })}

              {ungroupedMenu.map((item, index) => {
                const isActive = router.pathname === item.URL;
                const linkStyle = isActive ? selected : unSelected;
                return (
                  <li key={`ungrouped-${index}`} className={`${isActive ? 'active' : ''} ${collapsibleStyles.collapsedIconItem}`}>
                    <Tooltip placement="right" title={item.Name} overlayClassName={collapsibleStyles.sidebarTooltip}>
                      <Link legacyBehavior href={item.URL}>
                        <a style={linkStyle} className={collapsibleStyles.iconOnlyLink}>
                          <Image src={item.path} alt="" className="img-active" preview={false} />
                          <Image src={item.path} alt="" className="img-default" preview={false} />
                        </a>
                      </Link>
                    </Tooltip>
                  </li>
                );
              })}
            </ul>
          )}
        </div>

        <div className='sidebarBottom'>


          <Row>
            <Col span={24}>
              <ul className="sidebar-list pb-10">
                <>
                  <Avatar
                    // name={session ? session.user.name : ""}
                    name='?'
                    size="30"
                    onClick={openHelpModal}
                    title='Help'
                    round={true}
                    color=" rgb(12, 63, 107"
                    className='userProfile'
                  />
                  {!isCollapsed && <span style={userNameStyle}>Help</span>}

                  {
                    isModalHelp &&
                    <Modal
                      isOpen={isModalHelp}
                      onRequestClose={closeHelpModal}
                      contentLabel="Help"
                      style={{
                        overlay: {
                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                          zIndex: 1000,
                        }
                      }}
                      className={styles.userProfileModalPopup}
                    >
                      <button className={styles.onRequestClose} onClick={closeHelpModal}>
                        <span>&times;</span>
                      </button>

                      <div style={{ minWidth: '260px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px' }}>
                          <span style={{ fontSize: '20px' }}>❓</span>
                          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '700' }}>Help & Support</h3>
                        </div>

                        {activeRole !== 'Admin' && (
                          <>
                            <div style={{ ...helpItemStyle, cursor: 'pointer' }}
                              onClick={() => { setIsModalHelp(false); router.push('/help/user-guide'); }}
                              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#d6eaf8'}
                              onMouseLeave={e => e.currentTarget.style.backgroundColor = '#f0f4f8'}>
                              <span style={helpIconStyle}>📘</span>
                              <div>
                                <div style={{ fontWeight: '600', fontSize: '14px' }}>User Guides</div>
                                <div style={{ fontSize: '12px', color: '#667085' }}>Documentation &amp; manuals</div>
                              </div>
                            </div>
                            <div style={{ ...helpItemStyle, cursor: 'pointer', opacity: 0.85 }} onClick={() => { setIsFAQOpen(true); setIsModalHelp(false); }}>
                              <span style={helpIconStyle}>💬</span>
                              <div>
                                <div style={{ fontWeight: '600', fontSize: '14px' }}>FAQs</div>
                                <div style={{ fontSize: '12px', color: '#667085' }}>Frequently asked questions</div>
                              </div>
                            </div>
                            <div style={{ ...helpItemStyle, ...futureItemStyle }} onClick={() => { setComingSoonTitle('Raise a Ticket'); setIsModalHelp(false); }}>
                              <span style={helpIconStyle}>🎫</span>
                              <div>
                                <div style={{ fontWeight: '600', fontSize: '14px' }}>
                                  Raise a Ticket <span style={badgeStyle}>Coming Soon</span>
                                </div>
                                <div style={{ fontSize: '12px', color: '#667085' }}>EVA integration</div>
                              </div>
                            </div>
                            {activeRole !== 'Internal Manager' && activeRole !== 'Internal Admin' && (
                              <div style={{ ...helpItemStyle, cursor: 'pointer' }} onClick={(e) => {
                                e.stopPropagation();
                                const name = localStorage.name || '';
                                const to = 'HRSupport@fourcolorstech.com'.trim();
                                const subject = encodeURIComponent('Support Request');
                                const body = encodeURIComponent(`Hello,\n\n\nThanks & Regards,\n${name}`);
                                const a = document.createElement('a');
                                a.href = `https://outlook.cloud.microsoft/mail/deeplink/compose?to=${to}&subject=${subject}&body=${body}`;
                                a.target = '_blank';
                                a.rel = 'noopener noreferrer';
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                                setIsModalHelp(false);
                              }}>
                                <span style={helpIconStyle}>📩</span>
                                <div>
                                  <div style={{ fontWeight: '600', fontSize: '14px' }}>Contact Admin</div>
                                  <div style={{ fontSize: '12px', color: '#667085' }}>Send mail to HR Support</div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                        {activeRole === 'Admin' && (
                          <>
                            <div style={{ ...helpItemStyle, cursor: 'pointer' }} onClick={() => { setIsModalHelp(false); }}>
                              <span style={helpIconStyle}>📢</span>
                              <div>
                                <div style={{ fontWeight: '600', fontSize: '14px' }}>System Announcements</div>
                                <div style={{ fontSize: '12px', color: '#667085' }}>Manage announcements</div>
                              </div>
                            </div>
                            <div style={{ ...helpItemStyle, cursor: 'pointer' }} onClick={() => { setIsModalHelp(false); }}>
                              <span style={helpIconStyle}>⚙️</span>
                              <div>
                                <div style={{ fontWeight: '600', fontSize: '14px' }}>Support Configuration</div>
                                <div style={{ fontSize: '12px', color: '#667085' }}>Configure support settings</div>
                              </div>
                            </div>
                          </>
                        )}

                        <div style={{ borderTop: '1px solid #ddd', marginTop: '14px', paddingTop: '10px', textAlign: 'center' }}>
                          <div className={styles.PopUpLogo}>
                            <Image src={fctLogo} alt="Logo" height={22} preview={false} />
                          </div>
                          <p style={{ fontSize: '11px', color: '#999', margin: '6px 0 0' }}>EDX Version 2410</p>
                        </div>
                      </div>
                    </Modal>
                  }
                </>
              </ul>
            </Col>
            <br />
            <br />
            <Col span={24}>
              <ul className="sidebar-list pb-10">
                <>
                  <Avatar
                    // name={session ? session.user.name : ""}
                    name={localStorage.name ? localStorage.name : ""}

                    size="30"
                    onClick={openModal}
                    round={true}
                    color=" rgb(12, 63, 107"
                    className='userProfile'
                  />
                  {/* <span style={userNameStyle}>{session ? session.user.name : ""}</span> */}
                  {!isCollapsed && <span style={userNameStyle}>{localStorage.name ? localStorage.name : ""}</span>}
                  <UserProfileModal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                  />
                </>
              </ul>
            </Col>
          </Row>
        </div>
      </div>
      <HelpFAQModal isOpen={isFAQOpen} onClose={() => setIsFAQOpen(false)} />
      <ComingSoonModal isOpen={!!comingSoonTitle} onClose={() => setComingSoonTitle('')} title={comingSoonTitle} />
    </>
  )
}
